import React, { useContext, useEffect, useState } from "react";
import {
  HIDE_ASSIGN_DROPDOWN_TABS,
  TAB_NAME,
  TYPEOFUSER,
} from "../../../../constants/Constants";
import CustomDropDown from "../../../../components/CustomDropDown/CustomDropDown";
import {
  Dropdown,
  TooltipHost,
  PrimaryButton,
  ContextualMenu,
  IconButton,
  Stack,
} from "@fluentui/react";
import {
  assignButtonStyle,
  dropdownStyles,
  reAssignButtonStyle,
  radiologistNameStack,
  radiologistStackAssigned,
  reAssignButtonFirmStyle,
  superAdminAssignButtonStyle,
} from "../../helpers/initData";
import { t } from "i18next";
import { RowBadgeStatic } from "../RadiologistDetails";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import { CancelIcon } from "@fluentui/react-icons-mdl2";
import studylistContext from "../../../../context/studylist/StudylistContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import toastContext from "../../../../context/toast/ToastContext";
import userContext from "../../../../context/users/UserContext";
import RadiologistActiveIcon from "../../../../components/SVGComponents/RadiologistActiveIcon";

const FirmRadiologist = (props) => {
  const { batchUpdateIsClicked, setBatchUpdateIsClicked } =
    useContext(studylistContext);
  const { list } = useContext(toastContext);
  const [reassignClick, setReassignClick] = useState(null);
  const {contextSwitchUser, isActiveData} = useContext(userContext);

  const checkForAssignState = () => {
    if (
      props.data.row.original.assignmentList[0].providerId != null &&
      (props.data.row.original.assignmentList[0].providerId?.startsWith("R") ||
        props.data.row.original.assignmentList[0].providerId?.startsWith(
          "F"
        )) &&
      props.data.row.original.allowAssignment &&
      !HIDE_ASSIGN_DROPDOWN_TABS.includes(props.tabId)
    ) {
      return true;
    }
    return false;
  };

  useEffect(()=>{
    if(list?.length == 0){
      setReassignClick(null);
    }
  },[list])

  const checkForBadgeName = () => {
    if (props.data.row.original.assignmentList[0].providerId?.startsWith("R")) {
      return true;
    } else {
      return false;
    }
  };

  const checkForToolTipBadge = () => {
    if (props.data.row.original.assignmentList[0].providerId?.startsWith("R")) {
      return TYPEOFUSER.RADIOLOGIST;
    } else {
      return TYPEOFUSER.PROVIDER;
    }
  };

  const [reassignClicked, setReassignedClicked] = useState(
    checkForAssignState()
  );

  const [alreadyAssigned, setAlreadyAssigned] = useState(checkForAssignState());

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {HIDE_ASSIGN_DROPDOWN_TABS.includes(props.tabId) ? (
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "4px"
              }}
            >
              <span
                className="study-list-assignment-details-text"
                //style={{ paddingLeft: "4px" }}
              >
                <RowBadgeStatic
                  name={checkForBadgeName() ? "R" : "P"}
                  tooltipText={checkForBadgeName() ? t("radiologist.radiologist") : t("navbar.provider")}
                />
              </span>

              <CustomToolTipHost
                content={`${checkForToolTipBadge()}: ${
                  props.data.row.original.assignmentList[0].providerName ==
                  undefined
                    ? "-"
                    : props.data.row.original.assignmentList[0].providerName
                }`}
                id={
                  "tooltip_" +
                  props.data.row.original.assignmentList[0].providerName
                }
              >
                <span
                  className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                  style={{ width: "140px", display: "block" }}
                >
                  &nbsp;&nbsp;
                  {props.data.row.original.assignmentList[0]?.closedByProvider
                    ? `(${t("label.closed")}) `
                    : ""}
                  {props.data.row.original.assignmentList[0].providerName ==
                  undefined
                    ? t("label.not-assigned")
                    : props.data.row.original.assignmentList[0].providerName}
                </span>
              </CustomToolTipHost>
            </div>
          </div>
        ) : (
          <Stack horizontal style={radiologistNameStack}>
            {checkForAssignState() &&
            props.data.row.original.assignmentList[0].providerId != undefined &&
            reassignClick == null ? (
              <AlreadyAssignedCmp
                data={props.data}
                setReassignClick={setReassignClick}
                checkForBadgeName={checkForBadgeName}
                checkForToolTipBadge={checkForToolTipBadge}
                tabId={props.tabId}
              />
            ) : !checkForAssignState() &&
              props.data.row.original.assignmentList[0].providerId !=
                undefined &&
              !props.data.row.original.allowAssignment ? (
              <>
                <ReassignIfNotClicked
                  data={props.data}
                  setReassignClick={setReassignClick}
                  checkForBadgeName={checkForBadgeName}
                  checkForToolTipBadge={checkForToolTipBadge}
                />
              </>
            ) : (
              <>
                { !contextSwitchUser &&  props.data.row.original.allowAssignment && props.data.row.depth === 0 && (
                  <AssignmentDropDown
                    data={props.data}
                    setReassignClick={setReassignClick}
                    reassignClick={reassignClick}
                    getSelectedValue={props.getSelectedValue}
                    unselectRadiologist={props.unselectRadiologist}
                    handleSelection={props.handleSelection}
                    tabId={props.tabId}
                  />
                )}
                 {props.data.row.original.allowAssignment && props.data.row.depth > 0 && (
                  <span style={{paddingLeft: "10px"}}>-</span>
                )}
              </>
            )}
            {!checkForAssignState() &&
              props.data.row.original.assignmentList[0].providerId ==
                undefined &&
              !props.data.row.original.allowAssignment && (
                <div>
                  <span className="study-list-history-not-available">
                    {process.env.REACT_APP_VDC_PLATFORM == "true" ? t("string-literals.history-or-image-not-available") : t("string-literals.history-not-available")}
                  </span>
                </div>
              )}
            {props.data.row.original.assignmentList[0].closed == 0 &&
              props.data.row.original.reportDoneStatus < 2 &&
              props.data.row.original.showRadActiveStatus && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                  onClick={() => {
                    props.handleRadiologistTimeSpent();
                  }}
                >
                  <CustomToolTipHost
                  content={t("label.radiologist-active")}
                  id={"radiologist-active"}
                  >
                  <RadiologistActiveIcon></RadiologistActiveIcon>
                  </CustomToolTipHost>
                </div>
              )}
          </Stack>
        )}
      </div>
    </>
  );
};

export default FirmRadiologist;

const AlreadyAssignedCmp = (props) => {
  const {contextSwitchUser, isActiveData} = useContext(userContext);
  let sendForPeerReview = props.data.row.original.peerReviewAssignment;
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              className="study-list-assignment-details-text"
              //style={{ paddingLeft: "4px" }}
            >
              <RowBadgeStatic
                name={props.checkForBadgeName() ? "R" : "P"}
                tooltipText={
                  props.checkForBadgeName() ? t("radiologist.radiologist") : t("navbar.provider")
                }
              />
            </span>

            <CustomToolTipHost
              content={`${props.checkForToolTipBadge()}: ${
                props.data.row.original.assignmentList[0].providerName ==
                undefined
                  ? "-"
                  : props.data.row.original.assignmentList[0].providerName
              }`}
              id={
                "tooltip_" +
                props.data.row.original.assignmentList[0].providerName
              }
            >
              <span
                className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                style={{ width: "140px", display: "block" }}
              >
                &nbsp;&nbsp;
                {props.data.row.original.assignmentList[0]?.closedByProvider
                  ? `(${t("label.closed")}) `
                  : ""}
                {props.data.row.original.assignmentList[0].providerName ==
                undefined
                  ? "-"
                  : props.data.row.original.assignmentList[0].providerName}
              </span>
            </CustomToolTipHost>
          </div>

          {/* <span className="studylist-assignment-text-style studylist-assignment-return-text">
                  Assigned on{" "} 
                  {
                    props.data.row.original.assignmentList[0]
                      .assignmentDateDisplay
                  }
                </span> */}
        </div>
        {!contextSwitchUser && props.data.row.depth === 0 && !props.data.row.original.restrictionForVDC && !sendForPeerReview &&
          <div style={{ display: "flex", alignItems: "center" }}>
            <PrimaryButton
              text={t("button.reassign")}
              styles={reAssignButtonFirmStyle}
              className="study-list-assign-button"
              onClick={() => {
                props.setReassignClick(true);
              }}
              disabled={!isActiveData || (props.tabId == TAB_NAME.PENDING || props.tabId == TAB_NAME.APPROVED || props.tabId == TAB_NAME.REJECTED)}
            />
          </div>
        }
      </div>
    </>
  );
};

const ReassignIfNotClicked = (props) => {
  const { isActiveData } = useContext(userContext);
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginTop: `${
            !props.data.row.original.allowAssignment ? "4px" : "unset"
          }`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              className="study-list-assignment-details-text"
              //style={{ paddingLeft: "4px" }}
            >
              <RowBadgeStatic
                name={props.checkForBadgeName() ? "R" : "P"}
                tooltipText={
                  props.checkForBadgeName() ? t("radiologist.radiologist") : t("navbar.provider")
                }
              />
            </span>

            <CustomToolTipHost
              content={`${props.checkForToolTipBadge()}: ${
                props.data.row.original.assignmentList[0].providerName ==
                undefined
                  ? "-"
                  : props.data.row.original.assignmentList[0].providerName
              }`}
              id={
                "tooltip_" +
                props.data.row.original.assignmentList[0].providerName
              }
            >
              <span
                className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                style={{ width: "140px", display: "block" }}
              >
                &nbsp;&nbsp;
                {props.data.row.original.assignmentList[0]?.closedByProvider
                  ? `(${t("label.closed")}) `
                  : ""}
                {props.data.row.original.assignmentList[0].providerName ==
                undefined
                  ? "-"
                  : props.data.row.original.assignmentList[0].providerName}
              </span>
            </CustomToolTipHost>
          </div>

          {/* <span className="studylist-assignment-text-style studylist-assignment-return-text">
                    Assigned on{" "} 
                    {
                      props.data.row.original.assignmentList[0]
                        .assignmentDateDisplay
                    }
                  </span> */}
        </div>
        {props.data.row.original.allowAssignment && !props.data.row.original.restrictionForVDC && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <PrimaryButton
              text={t("button.reassign")}
              styles={reAssignButtonFirmStyle}
              onClick={() => {
                props.setReassignClick((prev) => !prev);
              }}
              disabled={!isActiveData}
            />
          </div>
        )}
      </div>
    </>
  );
};

export const AssignmentDropDown = (props) => {
  const { isActiveData } = useContext(userContext);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <CustomDropDown
          getSelectedValue={props.getSelectedValue}
          index={0}
          reassignClick={props.reassignClick}
          data={props.data}
          placeholder={t("placeholder.select-provider-radiologist")}
          unselectRadiologist={props.unselectRadiologist}
        />
        <PrimaryButton
          text={t("button.assign")}
          onClick={props.handleSelection}
          styles={
            props.superAdmin != null &&
            props.superAdmin != undefined &&
            props.superAdmin
              ? superAdminAssignButtonStyle
              : assignButtonStyle
          }
          disabled={!isActiveData || (props.tabId == TAB_NAME.PENDING || props.tabId == TAB_NAME.APPROVED || props.tabId == TAB_NAME.REJECTED)}
        />
        {props.reassignClick && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            {" "}
            <CancelIcon
              onClick={() => {
                props.setReassignClick(null);
                // props.data.row.original.assignmentList[0].providerId = props.data.row.original.assignmentList[0].providerIdStore;
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};
